import closeCompose from 'owa-mail-compose-actions/lib/actions/closeCompose';
import isPublicFolderComposeViewState from 'owa-mail-compose-store/lib/utils/isPublicFolderComposeViewState';
import trySaveMessage from 'owa-mail-compose-actions/lib/actions/trySaveMessage';
import trySendMessage from 'owa-mail-compose-actions/lib/actions/trySendMessage';
import updateContentToViewState from 'owa-editor/lib/utils/updateContentToViewState';
import { ComposeViewState } from 'owa-mail-compose-store';

export default function send(viewState: ComposeViewState, targetWindow: Window) {
    updateContentToViewState(viewState);

    if (isPublicFolderComposeViewState(viewState)) {
        trySaveMessage(viewState);
        closeCompose(viewState, 'SavePublicFolder');
    } else {
        trySendMessage(viewState, targetWindow).catch(error => error);
    }
}
